// @ts-nocheck

import Chart from "react-apexcharts";

import { dangerColor } from "../../assets/jss/app-js-styles";

const HeatMapChart = ({
  title,
  categories,
  data,
  height,
  width,
  showDataLabels,
  showToolbar,
  hideTooltip,
  customChartOption,
}) => {
  const chartData = {
    options: {
      colors: [dangerColor],
      dataLabels: {
        enabled: showDataLabels,
      },
      xaxis: categories
        ? {
            type: "category",
            categories: categories,
          }
        : {},
      title: {
        text: title,
      },
      tooltip: {
        enabled: !hideTooltip,
      },
      chart: {
        toolbar: {
          show: showToolbar,
        },
        ...customChartOption,
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      },
    },
  };
  return (
    <Chart
      options={chartData.options}
      series={data}
      type="heatmap"
      height={height}
      width={width}
    />
  );
};

HeatMapChart.defaultProps = {
  showToolbar: false,
  hideTooltip: false,
  showDataLabels: false,
  customChartOption: {},
};

export default HeatMapChart;
